import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { LegendItem } from '../../../components/Legend';
import { getCurrentLegend } from '../../../selectors/layerSelectors';

export function OtherImageryLegend({ intervals = [], testId }) {
  const isVisible = intervals.length > 0;

  return isVisible ? (
    <div data-test-id={`${testId}-other-imagery`}>
      <LegendItem intervals={intervals} />
    </div>
  ) : null;
}

OtherImageryLegend.propTypes = {
  intervals: PropTypes.arrayOf(PropTypes.object),
  testId: PropTypes.string.isRequired,
};

function mapStateToProps(state, props) {
  return {
    intervals: getCurrentLegend(state, props),
  };
}

export default connect(mapStateToProps)(OtherImageryLegend);
